import { Button } from 'primereact/button';
import Filtros from './filtros';

const Header = () => (
  <div className="bottom-sheet-header">
    <h2 className="mr-auto">Linha do tempo</h2>
    <Filtros />
    <Button text icon="pi pi-download text-color" disabled />
    <Button text icon="pi pi-angle-double-down text-color" disabled />
  </div>
);

export default Header;
